import { render, staticRenderFns } from "./SiteVersionIndex.vue?vue&type=template&id=8e2dfb14&lang=pug"
import script from "./SiteVersionIndex.vue?vue&type=script&lang=js"
export * from "./SiteVersionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports